import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteFieldFilterParams {
  id: string;
}

const deleteFieldFilter: MutationFunction<
  DeleteFieldFilterParams,
  DeleteFieldFilterParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockFieldFilter(args), { delay: 4000, failureRate: 1 });
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DeleteFieldFilterParams>(
    `/search-filters/${args.id}`,
    {
      method: 'DELETE',
    },
  );

  // DELETE requests typically return 204 No Content (no response.data)
  // Check for successful status codes instead of response.data
  if (response.status === 204 || response.status === 200) {
    return { id: args.id }; // Return the ID to confirm deletion
  }

  throw new Error('Failed to delete field filter');
};

export default deleteFieldFilter;

const _mockFieldFilter = (fieldFilter: DeleteFieldFilterParams) => {
  return {
    id: fieldFilter.id,
  };
};
